import { Button } from '../ui/Button'
import { useT } from '../../i18n/useT'

interface ConvertButtonProps {
  isLoading: boolean
  disabled: boolean
  onClick: () => void
}

export function ConvertButton({ isLoading, disabled, onClick }: ConvertButtonProps) {
  const t = useT()
  // No spinner here — the result panel below already shows the loading state
  return (
    <Button
      size="lg"
      disabled={disabled || isLoading}
      onClick={onClick}
      className="w-full"
    >
      {isLoading ? t('form.transcribing') : t('form.start')}
    </Button>
  )
}
